import { useOktaAuth } from '@okta/okta-react';
import { useBorrowerSearchPostMutation } from 'api/customPortalApi';
import { useEffect } from 'react';

const useBorrowerData = () => {
  const {
    authState: { isAuthenticated, idToken },
  } = useOktaAuth();

  const [loadBorrower, { data: borrower, isLoading }] = useBorrowerSearchPostMutation();

  useEffect(() => {
    if (!borrower && isAuthenticated && idToken) {
      const idTokenData = JSON.parse(atob(idToken.idToken.split('.')[1]));
      loadBorrower({ body: { email: idTokenData.email } });
    }
  }, [borrower, isAuthenticated, idToken]);

  return { borrower, isLoading, applicationId: borrower?.borrower.activeApplication?.id };
};

export default useBorrowerData;
